import { useTableContext } from "./TableContext";
import { ColumnVisibilityToggle, type ColumnGroup } from "@/components/ColumnVisibilityToggle";

interface TableColumnToggleProps {
  disabled?: boolean;
  groups?: ColumnGroup[];
}

export function TableColumnToggle({ disabled, groups }: TableColumnToggleProps) {
  const { table, loading } = useTableContext();

  return <ColumnVisibilityToggle table={table} disabled={disabled || loading} groups={groups} />;
}
